import { format as dateFnsFormat } from 'date-fns';
import { ru } from 'date-fns/locale';
import i18n from './i18n';
import { localeType } from './enums';

const locales = { ru };

export function format(date, formatStr = 'PP') {
  return dateFnsFormat(date, formatStr, { locale: locales[i18n.locale] });
}

export function yearsOld(date) {
  return Math.abs((new Date(Date.now() - date.getTime())).getUTCFullYear() - 1970);
}

export const DATE_FORMATS = Object.freeze({
  server: {
    short: 'yyyy-MM-dd',
  },
  [localeType.EN]: {
    short: 'MM/dd/yyyy',
  },
  [localeType.RU]: {
    short: 'dd.MM.yyyy',
  },
});

export const DATE_MASKS = Object.freeze({
  [localeType.EN]: {
    short: '##/##/#####',
  },
  [localeType.RU]: {
    short: '##.##.####',
  },
});
